import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '../shared/guard/auth.guard';
import { AppComponent } from './app.component';
import { LogOutComponent } from './log-out/log-out.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    canActivate: [authGuard]
  },
  {
    path: 'logout',
    component: LogOutComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
